import React, { Component } from 'react';
import './header.css';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem
} from 'reactstrap';
import Scrollchor from 'react-scrollchor';

class Header extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
  render() {
    return (
        <header>
		<Navbar className="header" dark expand="md">
            <NavbarBrand href="/">IGRECWAY</NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                    <NavItem>
                        <Scrollchor to="#apps" className="nav-link">Apps</Scrollchor>
                    </NavItem>
                    <NavItem>
                        <Scrollchor to="#about" className="nav-link"> About Us</Scrollchor>
                    </NavItem>
                    <NavItem>
                        <Scrollchor to="#contact" className="nav-link"> Contact</Scrollchor>
                    </NavItem>
                </Nav>
            </Collapse>
        </Navbar>
	</header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/header/header.js